module.exports = __webpack_public_path__ + "img/2.cdcb7355.png";